import { render, staticRenderFns } from "./MaterialEdit.vue?vue&type=template&id=ba623b7e&scoped=true&"
import script from "./MaterialEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialEdit.vue?vue&type=script&lang=js&"
import style0 from "./MaterialEdit.vue?vue&type=style&index=0&id=ba623b7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba623b7e",
  null
  
)

export default component.exports